export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const productionAnalyticsHosts = new Set(["nossabarcafe.com", "www.nossabarcafe.com"]);

export const restaurantImage =
  "https://customer-assets.emergentagent.com/job_d5db75cf-94a2-4271-8ec8-723a43e02b2a/artifacts/nk645zjf_5E8CFA34-12B5-4807-BFF2-8893F903B0FE.png";
export const logoImage = "https://customer-assets.emergentagent.com/job_nossa-cafe/artifacts/0ialx75d_IMG_0017.jpeg";
export const eventPopupImage = "https://customer-assets-gfyr7b9c.emergentagent.net/job_8df4882a-29cd-4351-a11c-8e5618968b43/artifacts/5vg2oph1_f683c471-f46b-481b-8fe3-f6cb65e64256.jpeg";
export const eventPopupExpiresAt = new Date("2026-07-19T23:59:00+02:00").getTime();
export const eventPopupSessionKey = "nossa-world-final-popup-closed";

export const fallbackBrand = {
  name: "NOSSA",
  slogan: "Tu lugar. Tu pausa. Tu momento.",
  purpose:
    "Nossa es un bar cafetería en Ciempozuelos dedicado a la pausa, el encuentro y el disfrute. Aquí cada persona puede sentirse bienvenida, cómoda y en calma, con una carta variada de desayunos, meriendas, raciones, hamburguesas, bocadillos y platos preparados con dedicación. Además, mientras nuestras puertas estén abiertas, nuestra cocina también lo está.",
  mission:
    "Crear un espacio acogedor donde las personas puedan disfrutar comida, café y momentos de calidad en un ambiente cálido y auténtico.",
  values: ["Cercanía", "Autenticidad", "Experiencia"],
};

export const fallbackContact = {
  address: "Plaza Mayor 11, 28350 Ciempozuelos, Madrid",
  phone: "+34 680 502 341",
  hours: [
    "Lunes · 09:00–21:00",
    "Martes · Cerrado",
    "Miércoles · 09:00–21:00",
    "Jueves · 09:00–21:00",
    "Viernes · 09:00–00:00",
    "Sábado · 09:30–00:00",
    "Domingo · 09:30–19:00",
  ],
  instagram: "@NOSSABARCAFE",
  tiktok: "@NOSSABARCAFE",
  email: "Email pendiente de confirmar",
  maps_url: "https://maps.app.goo.gl/fvx1CqdRSzHi6CiR7?g_st=ic",
};

export const fallbackReviews = {
  average_rating: 5.0,
  total_reviews_label: "3 reseñas destacadas de 5 estrellas",
  google_maps_url: "https://maps.app.goo.gl/fvx1CqdRSzHi6CiR7?g_st=ic",
  reviews: [
    {
      id: "review-ambiente",
      author: "Cliente de Google",
      rating: 5,
      text: "Un sitio muy acogedor, con buen ambiente y atención cercana. Perfecto para tomar algo y disfrutar con calma.",
      source: "Google",
    },
    {
      id: "review-comida",
      author: "Cliente de Google",
      rating: 5,
      text: "La comida está muy rica y se nota el cariño en cada plato. Volveremos seguro.",
      source: "Google",
    },
    {
      id: "review-servicio",
      author: "Cliente de Google",
      rating: 5,
      text: "Muy buena atención, café excelente y una carta con opciones para cualquier momento del día.",
      source: "Google",
    },
  ],
};

export const fallbackPartners = [
  {
    id: "uber-eats",
    name: "Uber Eats",
    label: "Pide para llevar",
    url: "https://www.ubereats.com/es/store/nossa-bar-cafe/5OpyAt60UkKSm5rItdtkbg",
    logo_url: "/uber-eats-logo.svg",
  },
  {
    id: "the-fork",
    name: "TheFork",
    label: "Reserva mesa",
    url: "https://wa.me/34680502341?text=Hola%20Nossa%2C%20quiero%20reservar%20una%20mesa",
    logo_url: "/thefork-logo.svg",
  },
];

export const fallbackMenu = [
  {
    id: "cafe-de-especialidad",
    name: "Café de especialidad",
    description: "Aromático, cálido y servido con calma para tu pausa diaria.",
    category: "Cafés",
    price: "Próximamente",
    image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1200&q=80",
    tag: "Café",
  },
  {
    id: "tostada-nossa",
    name: "Tostada Nossa",
    description: "Pan tostado, ingredientes frescos y sabor de casa.",
    category: "Desayunos",
    price: "Próximamente",
    image: "https://images.unsplash.com/photo-1525351484163-7529414344d8?auto=format&fit=crop&w=1200&q=80",
    tag: "Desayuno",
  },
  {
    id: "brunch-de-la-casa",
    name: "Brunch de la casa",
    description: "Una mesa para compartir, conversar y disfrutar sin prisa.",
    category: "Brunch",
    price: "Próximamente",
    image: "https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?auto=format&fit=crop&w=1200&q=80",
    tag: "Brunch",
  },
  {
    id: "plato-del-dia",
    name: "Plato del día",
    description: "Cocina honesta, cercana y pensada para sentirse bien.",
    category: "Comida",
    price: "Próximamente",
    image: "https://images.unsplash.com/photo-1543353071-873f17a7a088?auto=format&fit=crop&w=1200&q=80",
    tag: "Comida",
  },
  {
    id: "dulce-artesano",
    name: "Dulce artesano",
    description: "Un pequeño momento dulce para acompañar café o sobremesa.",
    category: "Dulces",
    price: "Próximamente",
    image: "https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=1200&q=80",
    tag: "Dulce",
  },
  {
    id: "aperitivo-nossa",
    name: "Aperitivo Nossa",
    description: "Sabores sencillos, bebidas y conversación al final del día.",
    category: "Bar",
    price: "Próximamente",
    image: "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1200&q=80",
    tag: "Bar",
  },
];

export const fallbackMenuNote =
  "Todos los productos pueden contener alérgenos o trazas por contaminación cruzada. Consulte al personal si tiene alguna alergia o intolerancia.";

export const navItems = [
  { path: "/", label: "Inicio", testId: "nav-home-link" },
  { path: "/menu", label: "Menú", testId: "nav-menu-link" },
  { path: "/promociones", label: "Promociones", testId: "nav-promotions-link" },
  { path: "/contacto", label: "Contacto", testId: "nav-contact-link" },
];

export const fallbackPromotions = [
  {
    id: "cerveza-barril-2x1",
    title: "Cerveza de barril 2x1",
    description: "Doble de cerveza 33cl. Promoción disponible todos los días de 15:00 a 19:00.",
    image_url: "https://customer-assets.emergentagent.com/job_nossa-cafe/artifacts/ij8w25dm_2e473411-f42c-4e59-97a9-6b8065d1fc81.jpeg",
    note: "Se sirve en barra con patatas de bolsa. Ciertas condiciones aplican.",
  },
  {
    id: "gigantes-nossa",
    title: "Los gigantes llegaron a Nossa",
    description: "DYC, Larios y Brugal a 4,50€. De lunes a sábado de 15:00 a 19:00 y domingos todo el día.",
    image_url: "https://customer-assets.emergentagent.com/job_nossa-cafe/artifacts/pfzg7ub0_c7e37aef-7784-411c-b2a4-3f8bdceb7ef2.jpeg",
    note: "Se sirve en barra con patatas de bolsa. Ciertas condiciones aplican.",
  },
];

export const categoryOrder = ["Desayunos", "Especialidad Venezolana", "Meriendas", "Para compartir", "Para comer", "Hamburguesas", "Bocadillos", "Bebidas"];

export function sortMenuItems(items) {
  return [...items].sort((a, b) => {
    const categoryDiff = categoryOrder.indexOf(a.category) - categoryOrder.indexOf(b.category);
    if (categoryDiff !== 0) return categoryDiff;
    return 0;
  });
}